import { CardContent, Sheet } from 'src/components';

import { useLingui } from '@lingui/react/macro';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { useHasEverPairedDeviceSuspense } from 'src/api/queries';
import { URLS } from 'src/utils/urls/urls';
import { OneTimeCode } from './OneTimeCode';

export const ConnectFlow = () => {
  const { t } = useLingui();
  const hasEverPairedDevice = useHasEverPairedDeviceSuspense();

  return (
    <div className="flex flex-col gap-16 lm:gap-24">
      <Sheet>
        <CardContent>
          <OneTimeCode
            hideBack
            successRedirectUrl={URLS.DEVICE_APPS}
            description={t`Enter this one-time code in the app to pair it with your reMarkable and sync your notes.`}
            allowPairing={hasEverPairedDevice.data}
            deviceTypeString="app"
            componentLocation={ComponentLocations.DEVICE.APPS}
          />
        </CardContent>
      </Sheet>
    </div>
  );
};
